import '../../vendor/slick.js';

(function ($) {
  $('.rotator').each(function () {
    var $this = $(this);

    $this.slick({
      slidesToShow: 1,
      arrows: true,
      dots: true,
      lazy: 'progressive',
      touchThreshold: 5000,
    });
  });
})(window.jQuery);
